/* Interactividad de la pagina de producto: galeria, variantes y cantidad. */
(function () {
  'use strict';

  /* Formatea centavos usando el formato de moneda de la tienda. */
  function dinero(cents) {
    var fmt = window.mtMoneyFormat || '{{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, tipo) {
      var sinDec = tipo.indexOf('no_decimals') > -1;
      var coma = tipo.indexOf('with_comma_separator') > -1;
      var apos = tipo.indexOf('with_apostrophe_separator') > -1;
      var n = cents / 100;
      var s = sinDec ? Math.round(n).toFixed(0) : n.toFixed(2);
      var partes = s.split('.');
      var milesSep = coma ? '.' : (apos ? "'" : ',');
      var decSep = coma ? ',' : '.';
      partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, milesSep);
      return partes.length > 1 ? partes[0] + decSep + partes[1] : partes[0];
    });
  }

  function initGaleria(root) {
    var minis = root.querySelector('[data-mt-galeria]');
    if (!minis) return;
    var id = minis.getAttribute('data-mt-galeria');
    var principal = root.querySelector('#mt-pdp-principal-' + id);
    if (!principal) return;
    minis.addEventListener('click', function (e) {
      var btn = e.target.closest('.mt-pdp__mini');
      if (!btn) return;
      principal.src = btn.getAttribute('data-mt-foto');
      minis.querySelectorAll('.mt-pdp__mini').forEach(function (b) { b.classList.remove('mt-activa'); });
      btn.classList.add('mt-activa');
    });
  }

  function initCantidad(root) {
    root.querySelectorAll('.mt-pdp__cantidad').forEach(function (caja) {
      var input = caja.querySelector('input');
      caja.addEventListener('click', function (e) {
        var b = e.target.closest('[data-mt-cant]');
        if (!b || !input) return;
        var n = parseInt(input.value, 10) || 1;
        n = b.getAttribute('data-mt-cant') === '+' ? n + 1 : Math.max(1, n - 1);
        input.value = n;
      });
    });
  }

  function initVariantes(root) {
    var datos = root.querySelector('[data-mt-variantes]');
    if (!datos) return;
    var variantes;
    try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
    if (!variantes || !variantes.length) return;

    var form = root.querySelector('.mt-pdp__form');
    if (!form) return;
    var campoId = form.querySelector('[data-mt-variante-id]');
    var boton = form.querySelector('[data-mt-boton]');
    var botonTxt = form.querySelector('[data-mt-boton-texto]');
    var elPrecio = root.querySelector('[data-mt-precio]');
    var elAntes = root.querySelector('[data-mt-antes]');
    var elAhorro = root.querySelector('[data-mt-ahorro]');
    var textoComprar = botonTxt ? botonTxt.textContent.trim() : 'Agregar al carrito';
    var textoAgotado = boton ? (boton.getAttribute('data-mt-agotado') || 'Sin stock por ahora') : '';

    function seleccion() {
      var out = [];
      root.querySelectorAll('.mt-pdp__opcion').forEach(function (op) {
        var marcado = op.querySelector('input:checked');
        out.push(marcado ? marcado.value : null);
      });
      return out;
    }

    function actualizar() {
      var sel = seleccion();
      if (!sel.length) return;
      var v = variantes.find(function (va) {
        return sel.every(function (val, i) { return va.options[i] === val; });
      });

      root.querySelectorAll('.mt-pdp__pill').forEach(function (p) {
        var inp = p.querySelector('input');
        p.classList.toggle('mt-activa', !!(inp && inp.checked));
      });

      if (!v) {
        if (boton) { boton.disabled = true; }
        if (botonTxt) { botonTxt.textContent = 'Combinacion no disponible'; }
        return;
      }

      if (campoId) campoId.value = v.id;
      if (elPrecio) elPrecio.textContent = dinero(v.price);

      if (elAntes && elAhorro) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          elAntes.textContent = dinero(v.compare_at_price);
          elAntes.hidden = false;
          elAhorro.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
          elAhorro.hidden = false;
        } else {
          elAntes.hidden = true;
          elAhorro.hidden = true;
        }
      }

      if (boton) boton.disabled = !v.available;
      if (botonTxt) botonTxt.textContent = v.available ? textoComprar : textoAgotado;
    }

    root.querySelectorAll('.mt-pdp__opcion input').forEach(function (inp) {
      inp.addEventListener('change', actualizar);
    });
    actualizar();
  }


  /* ---------- Packs por cantidad ----------
     Cada tarjeta es un radio llamado "quantity". Al elegirlo solo hay que
     mover la clase visual: el valor viaja solo en el formulario. */
  function initPacks(root) {
    var packs = root.querySelectorAll('.mt-pack');
    if (!packs.length) return;
    function pintar() {
      packs.forEach(function (p) {
        var inp = p.querySelector('input[data-mt-pack]');
        p.classList.toggle('mt-pack--activo', !!(inp && inp.checked));
      });
    }
    packs.forEach(function (p) {
      var inp = p.querySelector('input[data-mt-pack]');
      if (inp) inp.addEventListener('change', pintar);
    });
    pintar();
  }

  /* ---------- Agregar al carrito sin recargar ----------
     Manda el formulario por AJAX para que se abra el carrito lateral, y si la
     casilla de "comprados juntos" esta marcada agrega los dos productos en un
     solo envio con items[].
     IMPORTANTE: se usa new FormData(form) tal cual, nunca se arma el cuerpo a
     mano, porque asi viaja el campo "quantity" del pack elegido y el proveedor
     recibe la cantidad correcta. */
  /* Abre el formulario de pedido de EasySell directamente. Se prefiere el
     boton del cajon del carrito, que arma el pedido leyendo el carrito y por
     tanto respeta el pack elegido. El de la ficha se usa como respaldo.
     Los dos estan escondidos por CSS, pero un clic por codigo igual dispara
     su escuchador. */
  function abrirFormulario(intento) {
    intento = intento || 0;
    var b = document.querySelector('.es-popup-button-drawer') ||
            document.querySelector('.es-popup-button-cart') ||
            document.querySelector('.es-popup-button-product');
    if (b) { b.click(); return; }
    // La app tarda un momento en dibujar sus botones: se reintenta un poco.
    if (intento < 20) setTimeout(function () { abrirFormulario(intento + 1); }, 250);
  }

  function initAgregar(root) {
    var form = root.querySelector('.mt-pdp__form');
    if (!form || form.getAttribute('data-mt-ajax')) return;
    form.setAttribute('data-mt-ajax', '1');

    var boton = form.querySelector('[data-mt-boton]');
    var textoBoton = form.querySelector('[data-mt-boton-texto]');

    /* En una landing de campania el carrito sobra: quien viene de un anuncio
       tiene que ir del boton al formulario de pedido de un solo golpe. Se
       vacia el carrito, se agrega lo elegido y se abre el formulario, sin
       pasar por el cajon. */
    var esLanding = document.body.getAttribute('data-variante') === 'landing';

    form.addEventListener('submit', function (e) {
      var cajon = document.querySelector('cart-drawer');
      // Sin carrito lateral y fuera de una landing no hay nada que ganar.
      if (!cajon && !esLanding) return;
      e.preventDefault();

      var fd = new FormData(form);
      var id = fd.get('id');
      var cant = parseInt(fd.get('quantity'), 10) || 1;
      if (!id) return;

      var items = [{ id: id, quantity: cant }];

      var bump = root.querySelector('[data-mt-bump]');
      if (bump && bump.checked && bump.getAttribute('data-mt-bump-id')) {
        items.push({ id: bump.getAttribute('data-mt-bump-id'), quantity: 1 });
      }

      var previo = textoBoton ? textoBoton.textContent : '';
      if (boton) boton.setAttribute('disabled', 'disabled');
      if (textoBoton) textoBoton.textContent = 'Agregando...';

      var secciones = cajon && cajon.getSectionsToRender
        ? cajon.getSectionsToRender().map(function (s) { return s.id; })
        : ['cart-drawer', 'cart-icon-bubble'];

      var cuerpo = { items: items };
      if (!esLanding) {
        cuerpo.sections = secciones;
        cuerpo.sections_url = window.location.pathname;
      }

      /* En la landing se vacia primero: asi lo que se pide es exactamente el
         pack elegido, sin arrastrar nada de una visita anterior ni contar dos
         veces si vuelve a tocar el boton. */
      var antes = esLanding
        ? fetch(window.Shopify.routes.root + 'cart/clear.js', { method: 'POST' })
        : Promise.resolve();

      antes
        .then(function () {
          return fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(cuerpo)
          });
        })
        .then(function (r) { return r.json(); })
        .then(function (datos) {
          if (datos.status) {
            // Shopify devuelve 'status' solo cuando algo salio mal.
            if (textoBoton) textoBoton.textContent = datos.description || datos.message || 'No se pudo agregar';
            return;
          }
          if (textoBoton) textoBoton.textContent = previo;

          if (esLanding) {
            abrirFormulario();
            return;
          }
          if (cajon && cajon.renderContents) cajon.renderContents(datos);
          if (cajon && cajon.classList) cajon.classList.remove('is-empty');
        })
        .catch(function () {
          // Si falla la red, se manda el formulario como toda la vida.
          form.removeAttribute('data-mt-ajax');
          form.submit();
        })
        .finally(function () {
          if (boton) boton.removeAttribute('disabled');
        });
    });
  }


  /* ---------- Precios exactos ----------
     El descuento automatico de Shopify mira las unidades de TODO el carrito,
     no las de un producto. Asi que el precio que muestra cada pack se
     recalcula con esa misma regla, contando lo que ya hay en el carrito mas
     las unidades del pack mas el complemento si esta marcado.
     De esa forma lo que dice la pagina es exactamente lo que cobra el carrito:
     ni un guarani a favor nuestro ni del cliente. */
  function initPrecios(root) {
    var lista = root.querySelector('.mt-packs__lista');
    if (!lista) return;

    var precioUnidad = parseInt(lista.getAttribute('data-mt-precio-unidad'), 10);
    if (!precioUnidad) return;

    var escalones = [];
    try { escalones = JSON.parse(lista.getAttribute('data-mt-escalones') || '[]'); } catch (e) { escalones = []; }
    escalones.sort(function (a, b) { return b.desde - a.desde; });

    var bump = root.querySelector('[data-mt-bump]');
    var precioBump = 0;
    if (bump && bump.getAttribute('data-mt-bump-precio')) {
      precioBump = parseInt(bump.getAttribute('data-mt-bump-precio'), 10) || 0;
    }


    function porcentaje(unidades) {
      for (var i = 0; i < escalones.length; i++) {
        if (unidades >= escalones[i].desde) return escalones[i].pct;
      }
      return 0;
    }

    function guaranies(centavos) {
      var n = Math.round(centavos / 100);
      return 'Gs. ' + n.toLocaleString('es-PY').replace(/,/g, '.');
    }

    function pintar() {
      root.querySelectorAll('.mt-pack').forEach(function (p) {
        var cant = parseInt(p.getAttribute('data-mt-cant'), 10) || 1;
        // Cada fila, su propio escalon. La de 1 unidad va al precio de lista.
        // Como el carrito siempre lleva al menos estas unidades, su descuento
        // nunca va a ser menor que el que muestra la pagina: el cliente paga
        // lo mismo o menos, nunca mas.
        var pct = porcentaje(cant);
        var total = Math.round(precioUnidad * cant * (100 - pct) / 100);
        var porUnidad = Math.round(total / cant);

        var elTotal = p.querySelector('[data-mt-pack-total]');
        if (elTotal) elTotal.textContent = guaranies(total);

        var elUnidad = p.querySelector('[data-mt-pack-unidad]');
        if (elUnidad && cant > 1) elUnidad.textContent = guaranies(porUnidad) + ' c/u';

        var elEtiq = p.querySelector('[data-mt-pack-etiqueta]');
        if (elEtiq) {
          var base = elEtiq.getAttribute('data-mt-etiqueta-base') || '';
          // Se reescribe el porcentaje de la etiqueta para que no mienta.
          elEtiq.textContent = pct > 0 ? base.replace(/\d+\s*%/, pct + '%') : base.replace(/\s*·\s*\d+\s*%\s*OFF/i, '');
        }
      });

      // El complemento va a su precio de lista. Si el carrito termina con
      // suficientes unidades le va a tocar descuento, y entonces se cobra
      // menos de lo que dice aca. Nunca mas.
      if (bump && precioBump) {
        var elBump = root.querySelector('[data-mt-bump-precio-txt]');
        if (elBump) elBump.textContent = guaranies(precioBump);
      }
    }

    root.querySelectorAll('input[data-mt-pack]').forEach(function (i) { i.addEventListener('change', pintar); });
    if (bump) bump.addEventListener('change', pintar);
    pintar();
  }

  function initTodo() {
    document.querySelectorAll('.mt-pdp').forEach(function (root) {
      if (root.getAttribute('data-mt-listo')) return;
      root.setAttribute('data-mt-listo', '1');
      initGaleria(root);
      initCantidad(root);
      initVariantes(root);
      initPacks(root);
      initAgregar(root);
      initPrecios(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTodo);
  } else {
    initTodo();
  }
  document.addEventListener('shopify:section:load', initTodo);
})();


/* ---------------------------------------------------------------------------
   Los eventos de Meta ya NO se disparan desde aca.

   Desde el 6-sep-2026 los manda el canal oficial "Facebook & Instagram" de
   Shopify (PageView, ViewContent, AddToCart) mas EasySell por la API de
   conversiones (InitiateCheckout al abrirse el formulario y Purchase al
   confirmarse el pedido).

   El AddToCart que habia aca ya no podria funcionar: el canal de Shopify carga
   el pixel aislado y no deja "window.fbq" a la vista. Y la senial no se pierde,
   porque EasySell marca ese mismo momento con InitiateCheckout.
   ------------------------------------------------------------------------- */
